import consultas from './consultas'

export const consultasService = consultas
